import { createSlice } from '@reduxjs/toolkit';

import {
  GetContactInfo,
  GetFooterLinks,
  GetMediaLinks,
  GetPageContent,
} from '../../api/themesCalls';
import { getMediaByValue } from '../../Member/utils/common';

export const footerSlice = createSlice({
  name: 'footer',
  initialState: {
    isContantInfoLoaded: false,
    contactInfo: {},
    isLinksLoaded: false,
    linksInfo: {},
    isMediaLinksLoaded: false,
    mediaLinksInfo: {},
    pageContent: {},
  },
  reducers: {
    setContantInfoLoaded: (state) => {
      state.isThemeLoaded = true;
    },
    unSetLinks: (state) => {
      state.isLinksLoaded = false;
      state.linksInfo = null;
      state.isContantInfoLoaded = false;
      state.contactInfo = null;
      state.isMediaLinksLoaded = false;
    },
  },
  extraReducers: {
    [GetContactInfo.pending]: (state, action) => {
      state.isContantInfoLoaded = false;
    },
    [GetContactInfo.fulfilled]: (state, action) => {
      const response = action.payload.data.Response;
      state.isContantInfoLoaded = true;
      state.contactInfo = response || '';
    },
    [GetContactInfo.rejected]: (state, action) => {
      if (action?.error?.message.includes('404')) {
        state.isContantInfoLoaded = true;
      } else {
        state.isContantInfoLoaded = true;
      }
      state.contactInfo = {};
    },
    [GetFooterLinks.pending]: (state, action) => {
      state.isLinksLoaded = false;
    },
    [GetFooterLinks.fulfilled]: (state, action) => {
      const response = action.payload.data.Response;
      state.isLinksLoaded = true;
      state.linksInfo = response.Links || '';
    },
    [GetFooterLinks.rejected]: (state, action) => {
      if (action?.error?.message.includes('404')) {
        state.isLinksLoaded = true;
      } else {
        state.isLinksLoaded = true;
      }
      state.linksInfo = {};
    },
    [GetMediaLinks.pending]: (state, action) => {
      state.isMediaLinksLoaded = false;
    },
    [GetMediaLinks.fulfilled]: (state, action) => {
      state.isMediaLinksLoaded = true;
      const socialLinks = {};
      const response = action.payload.data.Response;
      if (response?.SocialMediaLinks) {
        response.SocialMediaLinks.map(
          (link) => (socialLinks[link.MediaType] = link),
        );
        const androidLink = getMediaByValue(
          response.SocialMediaLinks,
          'Mobile App - Google Play Store',
        );
        socialLinks['Android'] = androidLink;
        const appleLink = getMediaByValue(
          response.SocialMediaLinks,
          'Mobile App - Apple App Store',
        );
        socialLinks['iPhone'] = appleLink;
      }
      state.mediaLinksInfo = socialLinks;
    },
    [GetMediaLinks.rejected]: (state, action) => {
      if (action?.error?.message.includes('404')) {
        state.isMediaLinksLoaded = true;
      } else {
        state.isMediaLinksLoaded = true;
      }
      state.mediaLinksInfo = {};
    },
    [GetPageContent.pending]: (state, action) => {
      state.pageContent = null;
    },
    [GetPageContent.fulfilled]: (state, action) => {
      state.pageContent = action.payload.data.Response || '';
    },
    [GetPageContent.rejected]: (state, action) => {
      state.pageContent = 'no-data';
    },
  },
});

//Action creators are generated for each case reducer function
export const { setContantInfoLoaded, unSetLinks } = footerSlice.actions;

export default footerSlice.reducer;
